module.exports = __webpack_public_path__ + "static/img/cu.750c91b2.svg";